import { useState, useEffect } from "react";

/**
 * Custom hook to track the number of unsaved events, spaces, and products in localStorage.
 * 
 * @returns {Object} An object containing the counts:
 * - eventCount: Number of unsaved events.
 * - spaceCount: Number of unsaved spaces.
 * - totalProducts: Total number of products across all events and spaces.
 */
export default function useUnsavedCounts() {
    const [counts, setCounts] = useState({
        eventCount: 0,
        spaceCount: 0,
        totalProducts: 0,
    });

    useEffect(() => {
        const updateCounts = () => {
            const eventData = localStorage.getItem("eventData");
            const spaceData = localStorage.getItem("spaceData");

            const parsedEventData = eventData ? JSON.parse(eventData) : [];
            const parsedSpaceData = spaceData ? JSON.parse(spaceData) : [];

            const eventCount = parsedEventData.length;
            const spaceCount = parsedSpaceData.length;

            const totalProducts =
                parsedEventData.reduce(
                    (total, event) => total + (event.giftID ? event.giftID.length : 0),
                    0
                ) +
                parsedSpaceData.reduce(
                    (total, space) => total + (space.giftID ? space.giftID.length : 0),
                    0
                );

            setCounts({ eventCount, spaceCount, totalProducts });
        };

        // Initial update
        updateCounts();

        // Poll for changes every 500ms
        const interval = setInterval(updateCounts, 500);

        return () => clearInterval(interval);
    }, []);

    return counts;
}
